document.querySelectorAll('.image-tab-section').forEach(section => {
  const PLACEHOLDER = section.dataset.placeholder;
  const videoEl = section.querySelector('#heroVideo');
  const imgEl = section.querySelector('#heroImage');
  const items = section.querySelectorAll('.items-tab');

  if (!videoEl || !imgEl || !items.length) return;

  // Set the first image to fade in smoothly on load
  imgEl.classList.remove('fade-out');
  imgEl.classList.add('fade-in');
  setTimeout(() => {
    imgEl.classList.remove('fade-in');
  }, 400);

  // Preload all images
  items.forEach(item => {
    const rawUrl = item.dataset.image;
    if (rawUrl) {
      const fullUrl = rawUrl.startsWith('//') ? 'https:' + rawUrl : rawUrl;
      const preload = new Image();
      preload.src = fullUrl;
    }
  });

  // Attach event listeners
  items.forEach(item => {
    item.addEventListener('click', () => updateHero(item));
    item.addEventListener('mouseenter', () => updateHero(item));
  });

  function updateHero(activeItem) {
    items.forEach(i => i.classList.toggle('active', i === activeItem));

    const newImgSrc = activeItem.dataset.image?.startsWith('//')
      ? 'https:' + activeItem.dataset.image
      : activeItem.dataset.image || PLACEHOLDER;

    const newVidSrc = activeItem.dataset.video;

    if (newVidSrc) {
      // Fade out image
      imgEl.classList.remove('fade-in');
      imgEl.classList.add('fade-out');

      // Fade in video
      setTimeout(() => {
        imgEl.classList.remove('fade-out');
        imgEl.style.display = 'none';

        videoEl.src = newVidSrc;
        videoEl.style.display = 'block';
        videoEl.classList.remove('fade-out');
        videoEl.classList.add('fade-in');

        videoEl.addEventListener('transitionend', () => {
          videoEl.classList.remove('fade-in');
        }, { once: true });
      }, 500);
    } else {
      // Fade out video
      videoEl.classList.remove('fade-in');
      videoEl.classList.add('fade-out');

      setTimeout(() => {
        videoEl.removeAttribute('src');
        videoEl.style.display = 'none';
        videoEl.classList.remove('fade-out');

        // Preload and fade in image
        const tempImg = new Image();
        tempImg.onload = () => {
          imgEl.src = newImgSrc;
          imgEl.style.display = 'block';

          imgEl.classList.remove('fade-out');
          imgEl.classList.add('fade-in');

          imgEl.addEventListener('transitionend', () => {
            imgEl.classList.remove('fade-in');
          }, { once: true });
        };

        tempImg.src = newImgSrc;

        // Start fade out before switching
        imgEl.classList.remove('fade-in');
        imgEl.classList.add('fade-out');
      }, 500);
    }
  }
});
